import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { AppState } from './app.model';

export interface State extends EntityState<AppState> { }

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'app' })
export class AppStore extends EntityStore<State, AppState> {
    constructor() {
        super();
    }
}
